import request from '@/utils/request'

export default {
  // 取得條件組合列表
  getFavoriteListData (userId, purchaseType) {
    return request.get(`/api/v1/qp/favorites?current_user_id=${userId}&placement_type=${purchaseType}`)
  },
  // 建立條件組合
  createFavorite (params) {
    return request.post('/api/v1/qp/favorites', params)
  },
  // 取出條件組合
  getFavorite (id) {
    return request.get(`/api/v1/qp/favorites/${id}`)
  },
  // 刪除條件組合
  deleteFavorite (id) {
    return request.delete(`/api/v1/qp/favorites/${id}`)
  }
}
